var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('collection-image-create',{attrs:{"ams_template":_vm.ams_template,"reroute":_vm.reroute,"filtering":_vm.filtering}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }